import React, {Component} from 'react';

export default class DateHandler extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedDate: "Velg dato"
        };
    }

    dateChanged = (newDate) => {
        this.setState({
            selectedDate: newDate
        });

        var date = $('.date-picker').datepicker("getDate");
        var sendDate = $.datepicker.formatDate('yy-mm-dd', date);
        var printDate = $.datepicker.formatDate('dd - mm - yy', date);
        this.props.dateChangeCallback(sendDate, printDate);
    };

    componentDidMount() {
        var onSelect = this.dateChanged;
        var picker = $('.date-picker');
        picker.datepicker({
            firstDay: 1,
            dateFormat: 'dd - mm - yy',
            lang: 'no',
            onSelect: onSelect
        });
    }

    render() {
        return (
            <div className="date-picker"/>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/DateHandler.js